import { customInstance } from './mutator/custom-instance';
import type { TenantDto, UpdateTenantSettingsRequest } from '../types/tenantSettings';

const BASE = '/api/v1/tenant-settings';

export const getTenantSettings = () =>
  customInstance<TenantDto>({
    url: BASE,
    method: 'GET',
  });

export const updateTenantSettings = (data: UpdateTenantSettingsRequest) =>
  customInstance<TenantDto>({
    url: BASE,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json; version=1.0' },
    data,
  });
